/* eslint-disable no-console */
/* eslint-disable react/jsx-no-useless-fragment */
import rateSvc from '@efex-services/rate/rateSvc';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Currencies, ExtendedCurrencies } from '@constants/enums';
import {
  RealTimeCurrencies,
  setRealtimeData,
} from '@/modules/rate/realtime/store';
import { selectProfileData } from '../../../pages/profile/store/selectors';

const RELOAD_RATES = 20000;

interface WsCurrencyProps {
  children: JSX.Element;
}

const WsCurrency = ({ children }: WsCurrencyProps) => {
  const dispatch = useDispatch();
  const userProfile = useSelector(selectProfileData);
  const [counter, setCounter] = useState(1);

  const getAllRates = useCallback(async () => {
    const enterpriseId = userProfile?.company?.enterpriseId;
    if (!enterpriseId) return;

    const currencies = [
      ...Object.values(Currencies),
      ExtendedCurrencies.EUR,
      ExtendedCurrencies.GBP,
    ];
    const requests = currencies.flatMap((currency) =>
      currencies
        .filter((desCurrency) => desCurrency !== currency)
        .map((desCurrency) =>
          rateSvc.apiGetRate({ currency, desCurrency, enterpriseId })
        )
    );

    const response = await Promise.all(requests);
    dispatch(
      setRealtimeData({ data: response as unknown as RealTimeCurrencies })
    );
  }, [dispatch, userProfile?.company?.enterpriseId]);

  useEffect(() => {
    if (counter <= 0) getAllRates();
    const counterControl =
      counter > 0
        ? setInterval(() => setCounter(counter - 1), 1000)
        : setCounter(RELOAD_RATES / 1000);
    return () => clearInterval(counterControl as any);
  }, [counter, getAllRates]);

  return <>{children}</>;
};
export default WsCurrency;
